import { render, staticRenderFns } from "./sourceManage.vue?vue&type=template&id=54509cdc"
import script from "./sourceManage.vue?vue&type=script&lang=js"
export * from "./sourceManage.vue?vue&type=script&lang=js"
import style0 from "./sourceManage.vue?vue&type=style&index=0&id=54509cdc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports